import { render } from "./CreateBrandModal.vue?vue&type=template&id=f37c893c"
import script from "./CreateBrandModal.vue?vue&type=script&lang=js"
export * from "./CreateBrandModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__